import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/login/")({
  validateSearch: (search: Record<string, unknown>) => {
    return {
      redirect: search.redirect as string | undefined,
    }
  },
})
